import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_BASE } from "../../config/api";

const CareerListSection = () => {
  const { t } = useTranslation();
  const [jobOpenings, setJobOpenings] = useState([]);
  const [status, setStatus] = useState({ loading: true, error: "" });

  useEffect(() => {
    let ignore = false;

    const loadJobOpenings = async () => {
      setStatus({ loading: true, error: "" });
      try {
        const response = await fetch(`${API_BASE}/job-openings?limit=1000`);
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.message || "Unable to load job openings.");
        }

        const openings = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];

        if (!ignore) {
          setJobOpenings(openings);
          setStatus({ loading: false, error: "" });
        }
      } catch (error) {
        if (!ignore) {
          setStatus({
            loading: false,
            error: error.message || "Unable to load job openings.",
          });
        }
      }
    };

    loadJobOpenings();

    return () => {
      ignore = true;
    };
  }, []);

  const normalizeEmploymentTypes = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string" && value.trim()) return [value.trim()];
    return [];
  };

  const formatEmploymentType = (value) =>
    normalizeEmploymentTypes(value)
      .map((item) =>
        item
          .toLowerCase()
          .split("_")
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(" ")
      )
      .join(", ");

  const resolveLabel = (key, fallback) => t(key, { defaultValue: fallback }) || fallback;

  return (
    <section id="career" className="section-padding career-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center">
            <div className="wpo-section-title">
              <h2 style={{ fontWeight: "bold" }}>{t("career_title")}</h2>
            </div>
          </div>
        </div>
        {status.loading && (
          <div className="text-center">
            <p>{resolveLabel("career_loading", "Loading job openings...")}</p>
          </div>
        )}
        {status.error && (
          <div className="alert alert-danger" role="alert">
            {status.error}
          </div>
        )}
        {!status.loading && !status.error && jobOpenings.length === 0 && (
          <div className="text-center">
            <p>{resolveLabel("career_no_openings", "No jobs available at the moment.")}</p>
          </div>
        )}
        {!status.loading && !status.error && jobOpenings.length > 0 && (
          <div className="career-list-card">
            <div className="career-list-header">
              <span>{resolveLabel("career_list_title", "Job Title")}</span>
              <span>{resolveLabel("career_list_type", "Employment Type")}</span>
              <span>{resolveLabel("career_list_location", "Location")}</span>
            </div>
            <div className="career-list-body">
              {jobOpenings.map((opening) => (
                <Link
                  key={opening.id}
                  className="career-list-row"
                  to={`/career/${opening.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="career-list-title">{opening.title}</span>
                  <span>{formatEmploymentType(opening.employmentType)}</span>
                  <span>{opening.location}</span>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CareerListSection;
